export const getCardBrandImage = (brand: string, light = false) => {
  switch (brand.toLowerCase()) {
    case 'american express':
      if (light) {
        return require('../../../assets/payments/american-express-light.png');
      }

      return require('../../../assets/payments/american-express.png');
    case 'diners club':
      if (light) {
        return require('../../../assets/payments/diners-club-light.png');
      }

      return require('../../../assets/payments/diners-club.png');
    case 'discover':
      if (light) {
        return require('../../../assets/payments/discover-light.png');
      }

      return require('../../../assets/payments/discover.png');
    case 'jcb':
      if (light) {
        return require('../../../assets/payments/jcb-light.png');
      }

      return require('../../../assets/payments/jcb.png');
    case 'mastercard':
      if (light) {
        return require('../../../assets/payments/mastercard-light.png');
      }

      return require('../../../assets/payments/mastercard.png');
    case 'unionpay':
      if (light) {
        return require('../../../assets/payments/unionpay-light.png');
      }

      return require('../../../assets/payments/unionpay.png');
    case 'visa':
      if (light) {
        return require('../../../assets/payments/visa-light.png');
      }

      return require('../../../assets/payments/visa.png');
    default:
      return '';
  }
};
